import * as React from 'react';
import { useTranslation } from 'react-i18next';

import ServiceSummary from '../../ServiceSummary';
import { CartContext } from '../Cart';
import { CartServiceProps } from '../types';
import { ServiceSummaryType } from '../../ServiceSummary/types';
import { CheckoutSteps } from '../../MobileStepbar/types';
import BaggageSummary from '../../ServiceSummary/services/BaggageSummary';
import { CdnIcon } from '@shared/ui';

const Baggage: React.FC<CartServiceProps> = ({ onServiceDelete, renderService, activeStep, steps }) => {
	const cartConfig = React.useContext(CartContext);

	const { t } = useTranslation('Cart');

	const group: ServiceSummaryType = {
		header: t('Baggage'),
		icon: <CdnIcon icon={'Baggage/Checked-in'} />,
		totalPrice: cartConfig.totalPrices?.baggage,
		disabled: activeStep < steps?.findIndex(step => step.type === CheckoutSteps.Baggage) || false
	};

	return (
		<BaggageSummary onServiceDelete={onServiceDelete}>
			{content =>
				renderService?.(CheckoutSteps.Baggage, group, content) ?? (
					<ServiceSummary group={group}>{content}</ServiceSummary>
				)
			}
		</BaggageSummary>
	);
};

export default Baggage;
